import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { StaticQuery, graphql } from 'gatsby';

import '../assets/sass/grayscale.scss';
import seoImage from '../assets/images/Home_HeroImage.jpg';

class Layout extends Component {
  render() {
    const { children } = this.props;
    return (
      <StaticQuery
        query={graphql`
          query SiteTitleQuery {
            site {
              siteMetadata {
                title
              }
            }
          }
        `}
        render={data => (
          <>
            <Helmet
              title={data.site.siteMetadata.title}
              meta={[
                { name: 'description', content: 'WE/ARE FIVE/WE ARE ONE/' },
                { name: 'keywords', content: 'site, web' },
                { property: 'og:title', content: 'B/S/H/' },
                { property: 'og:description', content: 'WE/ARE FIVE/WE ARE ONE/' },
                { property: 'og:url', content: 'https://bsh.oskberlin.net/' },
                { property: 'og:image', content: 'https://bsh.oskberlin.net' + seoImage }
              ]}
            >
              <html lang="en" />
            </Helmet>
            <div className={'page-top'}>{children}</div>
          </>
        )}
      />
    );
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
